


















































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import DollarIcon from 'mdi-vue/CurrencyUsd';
import CloseIcon from 'mdi-vue/Close';

import LayoutContent from '@/components/LayoutContent.vue';
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';
import Accordion from '@/components/Accordion.vue';
import Loader from '@/components/Loader.vue';
import ToggleLanguage from '@/components/ToggleLanguage.vue';

import { State } from '@/store/disbursement';

import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import api from '@/libs/api';
import topupLocale from '@/locale/topup';

import { User } from '@/libs/api.interfaces';
import BalanceBox from './BalanceBox.vue';

@Component({
  components: {
    LayoutContent,
    Modal,
    Button,
    Loader,
    BalanceBox,
    Accordion,
    DollarIcon,
    CloseIcon,
    ToggleLanguage,
  },
  computed: mapState(['disbursement', 'user']),
})
export default class BalanceJumbotron extends Vue {
  disbursement!: State;
  user!: {
    user: User;
  };

  showModalVa = false;

  loadingVaNumber = true;
  numbers: { [key: string]: string } = {};
  clientName = '';
  copySuccess = false;

  language = false;
  locale = topupLocale.en;

  mounted() {
    this.getVaNumber();
  }

  @Watch('language')
  changeLanguage() {
    this.locale = topupLocale[this.language ? 'id' : 'en'];
  }

  openModal() {
    this.showModalVa = true;
    console.log('changed');
  }

  closeModal() {
    this.showModalVa = false;
  }

  // copyText = (text: string) => {
  //   if (navigator.clipboard) {
  //     navigator.clipboard.writeText(text)
  //       .then(() => {
  //         console.log('Text copied to clipboard');
  //         showToast(ToastType.SUCCESS, 'SUCCESS', `Number va ${text} to clipboard`);
  //       })
  //       .catch((err) => {
  //         console.error('Failed to copy text: ', err);
  //         showToast(ToastType.FAILED, 'Error', `Number va ${text} to clipboard`);
  //       });
  //   } else {
  //     console.error('Clipboard API not available');
  //   }
  // }

  // copyText(text: string) {
  //   const textarea = document.createElement('textarea');
  //   textarea.value = text;
  //   document.body.appendChild(textarea);

  //   textarea.select();
  //   // document.execCommand('copy');
  //   document.body.removeChild(textarea);

  //   this.copySuccess = true;
  //   showToast(ToastType.SUCCESS, 'SUCCESS', `${text} text has been copied`);
  //   setTimeout(() => {
  //     this.copySuccess = false;
  //   }, 2000);
  // }

  async copyText(text: string) {
    try {
    // Use the Clipboard API for copying text
      await navigator.clipboard.writeText(text);

      this.copySuccess = true;
      showToast(ToastType.SUCCESS, 'SUCCESS', `${text} text has been copied`);

      setTimeout(() => {
        this.copySuccess = false;
      }, 2000);
    } catch (error) {
      console.error('Failed to copy text: ', error);
      showToast(ToastType.FAILED, 'ERROR', 'Failed to copy text');
    }
  }

  async getVaNumber() {
    try {
      this.loadingVaNumber = true;
      const { data } = await api.get('/disbursement/clientva');
      this.numbers = data.data;
      this.clientName = data.client_name;
      this.loadingVaNumber = false;
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'Failed to get Virtual Account number');
    }
  }
}
